import { render, staticRenderFns } from "./Outfit.vue?vue&type=template&id=383774e9&scoped=true"
import script from "./Outfit.vue?vue&type=script&lang=js"
export * from "./Outfit.vue?vue&type=script&lang=js"
import style0 from "./Outfit.vue?vue&type=style&index=0&id=383774e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383774e9",
  null
  
)

export default component.exports